var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33337C4.32416 1.33337 1.3335 4.32404 1.3335 8.00004C1.3335 11.676 4.32416 14.6667 8.00016 14.6667C8.9775 14.6667 9.97416 14.4194 10.9615 13.9307L10.3715 12.7354C9.56883 13.132 8.77083 13.3334 8.00016 13.3334C5.0595 13.3334 2.66683 10.9407 2.66683 8.00004C2.66683 5.05937 5.0595 2.66671 8.00016 2.66671C10.9408 2.66671 13.3335 5.05937 13.3335 8.00004V8.66671C13.3335 9.12804 13.1248 10 12.3335 10C11.4028 10 11.3375 8.78737 11.3335 8.66671V5.33337H10.0002V5.35004C9.42634 4.90934 8.72368 4.66926 8.00016 4.66671C6.16216 4.66671 4.66683 6.16204 4.66683 8.00004C4.66683 9.83804 6.16216 11.3334 8.00016 11.3334C8.96683 11.3334 9.83216 10.9127 10.4415 10.2527C10.7908 10.846 11.3802 11.3334 12.3335 11.3334C13.8488 11.3334 14.6668 9.95937 14.6668 8.66671V8.00004C14.6668 4.32404 11.6762 1.33337 8.00016 1.33337ZM8.00016 10C6.8975 10 6.00016 9.10271 6.00016 8.00004C6.00016 6.89737 6.8975 6.00004 8.00016 6.00004C9.10283 6.00004 10.0002 6.89737 10.0002 8.00004C10.0002 9.10271 9.10283 10 8.00016 10Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtLogo);
export default __webpack_public_path__ + "static/media/atLogo.10148c76723e43d86a69cfb6bb374b5a.svg";
export { ForwardRef as ReactComponent };